import ColorPreset from './ColorPreset.js';
import StringToColorConverter from '../../util/StringToColorConverter.js'

export default class AliasColorScheme {
	constructor() {
		this._presets = {
			batch: new ColorPreset(),
			global: new ColorPreset()
		}
	}

	/** @returns {ColorPreset} */
	getGlobalColorPreset() {
		return this._presets.global;
	}

	/** @param {ColorPreset} preset */
	setGlobalColorPreset(preset) {
		this._presets.global = preset;
	}

	/** @returns {ColorPreset} */
	getBatchColorPreset() {
		return this._presets.batch;
	}

	/** @param {ColorPreset} preset */
	setBatchColorPreset(preset) {
		this._presets.batch = preset;
	}

	/**
	 * @param {string} alias
	 * @returns {string}
	 */
	getColor(alias) {
		let color = this.getPresetColor(alias)
		if (!color)
			color = this.getDefaultColor(alias)
		return color;
	}

	/**
	 * @param {string} alias
	 * @returns {string}
	 */
	getPresetColor(alias) {
		let color = this._presets.batch.getColor(alias);
		if (!color)
			color = this._presets.global.getColor(alias);
		return color;
	}

	/**
	 * @param alias
	 * @returns {string}
	 */
	getDefaultColor(alias) {
		return StringToColorConverter.convert(alias);
	}
}